import { Header } from "../shared/Header";
import { Main } from "../shared/Main";
import { Skeleton } from "../ui/skeleton";

const TablePageSkeleton = () => {
  return (
    <>
      <Header />
      <Main>
        <div className="flex justify-between items-center mb-8">
          <Skeleton className="w-60 h-9" />
          <Skeleton className="w-33 h-9" />
        </div>
        <div className="flex mb-6 gap-4">
          <div className="relative w-full max-w-md">
            <Skeleton className="w-full h-9" />
          </div>
          <div className="w-full max-w-xs">
            <Skeleton className="h-9 w-26" />
          </div>
        </div>
        <div className="w-full space-y-4">
          <div className="rounded-md border">
            <div className="border-b p-3">
              <div className="flex items-center justify-between space-x-4">
                <Skeleton className="h-4 w-12" />
                <Skeleton className="h-4 w-12" />
                <Skeleton className="h-4 w-12" />
                <Skeleton className="h-4 w-24" />
              </div>
            </div>
            {Array.from({ length: 10 }).map((_, i) => (
              // eslint-disable-next-line @eslint-react/no-array-index-key
              <div key={i} className="border-b p-4 last:border-0">
                <div className="flex items-center justify-between space-x-4">
                  <Skeleton className="h-5 w-40" />
                  <Skeleton className="h-5 w-40" />
                  <Skeleton className="h-5 w-40" />
                  <Skeleton className="h-5 w-8" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </Main>
    </>
  );
};

export default TablePageSkeleton;
